<template>
    <div class="tag-color-picker">
        <button
            v-for="color in TAG_COLORS"
            :key="color"
            type="button"
            class="swatch"
            :class="{ selected: color === modelValue }"
            :style="{ background: color }"
            :aria-label="'Couleur ' + color"
            @click="emit('update:modelValue', color)" />
    </div>
</template>

<script lang="ts" setup>
import { TAG_COLORS } from '@ezio/features/tags/types'

defineProps<{ modelValue?: string }>()
const emit = defineEmits<{ (e: 'update:modelValue', value: string): void }>()
</script>

<style lang="scss" scoped>
.tag-color-picker {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 8px;
}

.swatch {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid transparent;
    cursor: pointer;
    padding: 0;
    transition: transform 0.15s ease;

    &:hover {
        transform: scale(1.08);
    }

    &.selected {
        border-color: var(--c-text-color);
        box-shadow: 0 0 0 2px #fff inset;
    }
}
</style>
